export default {
    cn: {
        annualInterestBonus: {
            accHead: [
                { key: 'group', value: '组别' },
                { key: 'interest', value: '年息值' },
                { key: 'comment', value: '利息订单备注' },
                { key: 'balanceZero', value: '账户负余额保护' },
                { key: 'modify_by', value: '最后修改人' },
            ],
            addGroupTxt: '组别(格式为MT5格式,例如demo*,!demoforex)',
            addInterestTxt: '年息值(单位为%)',
            addCommentTxt: '利息订单备注',
            addBalanceZeroTxt: '账户负余额保护',

            interestlRulesRequired: '请输入年息值',
            interestRulesInvalid: '请输入正确的年息格式',
            groupRulesRequired: '请输入组别',
            groupRulesInvalid: '请输入正确的组别格式',
            commentRulesRequired: '请输入利息订单备注',
            commentRulesInvalid: '利息订单备注不能超过23字节',

            balanceZeroMapping: { 0: '否', 1: '是' },

            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作',
        }
    },
    hk: {
        annualInterestBonus: {
            accHead: [
                { key: 'group', value: '組別' },
                { key: 'interest', value: '年息值' },
                { key: 'comment', value: '利息訂單備註' },
                { key: 'balanceZero', value: '賬戶餘額保護' },
                { key: 'modify_by', value: '最後修改人' },
            ],
            addGroupTxt: '組別(格式為MT5格式,例如demo*,!demoforex)',
            addInterestTxt: '年息值(單位為%)',
            addCommentTxt: '利息訂單備註',
            addBalanceZeroTxt: '賬戶餘額保護',

            interestlRulesRequired: '請輸入年息值',
            interestRulesInvalid: '請輸入正確的年息格式',
            groupRulesRequired: '請輸入組別',
            groupRulesInvalid: '請輸入正確的組別格式',
            commentRulesRequired: '請輸入利息訂單備註',
            commentRulesInvalid: '利息訂單備註不能超過23字節',

            balanceZeroMapping: { 0: '否', 1: '是' },

            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作',
        }
    },
    en: {
        annualInterestBonus: {
            accHead: [
                { key: 'group', value: 'Group' },
                { key: 'interest', value: 'Interest' },
                { key: 'comment', value: 'Comment' },
                { key: 'balanceZero', value: 'Balance Zero' },
                { key: 'modify_by', value: 'Modify By' },
            ],
            addGroupTxt: 'Group(Format is MT5 format, such as demo*,!demoforex)',
            addInterestTxt: 'Annual interest(in %)',
            addCommentTxt: 'Comment',
            addBalanceZeroTxt: 'Balance Zero',

            interestlRulesRequired: 'Please enter the annual interest',
            interestRulesInvalid: 'Please enter the correct annual interest format',
            groupRulesRequired: 'Please enter the group',
            groupRulesInvalid: 'Please enter the correct group format',
            commentRulesRequired: 'Please enter the comment',
            commentRulesInvalid: 'Interest order comment cannot exceed 23 byte',

            balanceZeroMapping: { 0: 'No', 1: 'Yes' },

            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/annualInterestBonus.js